const formatBelgianPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '')

  if (cleaned.startsWith('32')) {
    if (cleaned.length === 11) {
      return `+32 ${cleaned.slice(2, 5)} ${cleaned.slice(5, 7)} ${cleaned.slice(
        7,
        9,
      )} ${cleaned.slice(9)}`
    } else if (cleaned.length === 10) {
      return `+32 ${cleaned.slice(2, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(
        6,
        8,
      )} ${cleaned.slice(8)}`
    }
  }

  return phone
}

export default formatBelgianPhoneNumber
